import React, {useEffect, useRef, useState} from 'react';
import {FormattedMessage, injectIntl} from "react-intl";
import {connect} from "react-redux";

import SvgIcons from "../Icons/SvgIcons";

import {copySelectedWizardItems, getWizardList} from "./wizardActions";
import {getAvailableWizardVisualizerOptions} from "./WizardSetupTopVisualizerSelect";
import useOutsideClick from "../../utilities/helperHooks";


const WizardSetupTopButtonsCopyButton = (props) => {

  const {wizardList, wizardListReceived, copySelectedWizardItems, fabricatorSubscriptions, wizardVisualizer, intl,
    getWizardList} = props;

  const selectedWizards = wizardList.filter(wizardItem => wizardItem.selected);
  const disabled = !wizardListReceived || !wizardList.length || !selectedWizards.length || !fabricatorSubscriptions.length;
  const [opened, setOpened] = useState(false);
  const [cloneToVisualizer, setCloneToVisualizer] = useState(wizardVisualizer);

  const anotherVis = cloneToVisualizer !== wizardVisualizer;

  const selectElement = useRef(null);

  useOutsideClick(selectElement, () => {
    if (opened) {
      setOpened(false);
    }
  });

  useEffect(() => {
    setCloneToVisualizer(wizardVisualizer);
  }, [wizardVisualizer]);

  const cloneWizardClick = () => {
    if (disabled) {
      return false
    }
    copySelectedWizardItems(selectedWizards, anotherVis ? cloneToVisualizer : "", getWizardList);
  }

  const handleSelectItemClick = (selectItem) => {
    setCloneToVisualizer(selectItem.value);
    setOpened(false);
  }

  const dropDownItems = getAvailableWizardVisualizerOptions(fabricatorSubscriptions, intl)
  const selectedItem = cloneToVisualizer ? dropDownItems.find(item => item.value === cloneToVisualizer) : null;

  const styles = {
    height: opened
      ? (dropDownItems.length * 30) + "px"
      : 0
  }

  return (
    <div className={"select3" + (opened ? " select3--active" : "")}>
      <button className={"ui-button--add ui-button5 ui-button5--gray ui-button5--no-right-radius ui-button5--select-all " + (disabled ? " ui-button5--disabled" : "")}
              onClick={cloneWizardClick}>
        <div className="ui-button-icon">
          {SvgIcons.copyIcon}
        </div>
        <span className="ui-button5__left-text">
          <FormattedMessage id="wizard.copyButton"/>
          {anotherVis ? " To:" : null}
        </span>
        {anotherVis
          ? <span className="secondary ui-button5__right-text ui-link">{selectedItem ? selectedItem.text : cloneToVisualizer}</span>
          : null}
      </button>
      <button className={"dropdown__arrow-button ui-button5 ui-button5--gray"
        + (opened ? " opened" : "")
        + (disabled ? " ui-button5--disabled" : "")}
              onClick={() => disabled ? null : setOpened(!opened)}/>
      <div className="select3-dropdown" style={styles} ref={selectElement}>
        <ul className={"select3-dropdown__list"}>
          {dropDownItems.map((selectItem, selectItemIndex) => {
            return (
              <li className="select3-dropdown__list-item"
                  key={selectItem.text + selectItemIndex}
                  onClick={() => handleSelectItemClick(selectItem)}>
                <span className={"select3-dropdown__list-item-text"}>
                  {selectItem.text}
                </span>
              </li>
            )
          })}
        </ul>
      </div>
    </div>
  )
};

const mapStateToProps = (store) => {
  const {wizardList, wizardListReceived, wizardVisualizer} = store.wizardState;
  const {fabricatorSubscriptions, fabricatorSubscriptionsReceived} = store.newScope;

  return {
    fabricatorSubscriptions,
    fabricatorSubscriptionsReceived,
    wizardList,
    wizardListReceived,
    wizardVisualizer,
  };
};

const mapDispatchToProps = {
  copySelectedWizardItems,
  getWizardList,
};

export default injectIntl(
  connect(mapStateToProps, mapDispatchToProps)(WizardSetupTopButtonsCopyButton)
)
